import { BaseModel } from './base/base.model';

export class GestionEmpleado extends BaseModel {}
